module.exports = __webpack_public_path__ + "static/infla-3b0709ad5f88de2402fb78b2853f8b8a.png";